(function () {
  console.log("Valentine script loaded");

  const overlay = document.createElement("div");
  overlay.id = "valentine-overlay";
  document.body.appendChild(overlay);

  const symbols = ["❤️", "💖", "🌹", "💘"];

  function drop() {
    const el = document.createElement("div");
    el.className = "valentine-item";
    el.textContent = symbols[Math.floor(Math.random() * symbols.length)];

    el.style.left = Math.random() * window.innerWidth + "px";
    el.style.fontSize = Math.random() * 16 + 16 + "px";
    el.style.animationDuration = Math.random() * 5 + 6 + "s";

    overlay.appendChild(el);

    setTimeout(() => el.remove(), 8000);
  }

  setInterval(drop, 250);
})();
